import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      currentCategory: 0,
      currentOffset: 0,
      limit: 50,
      searchFilterParams: {},
      infinitScrollState: null,
    };
  },
  computed: {
    ...mapState({
      historyDates: (state) => state.log.historyDates,
      historyDatesChecked: (state) => state.log.historyDatesChecked,
    }),
  },
  methods: {
    ...mapActions('log', ['clearLogByCategory', 'fetchLogByCategory']),
    handleSearch($refs, filterParams) {
      this.searchFilterParams = filterParams;
      this.currentOffset = 0;
      if ($refs.infinitScroll && $refs.infinitScroll.stateChanger) {
        $refs.infinitScroll.stateChanger.reset();
      }
      this.clearLogByCategory({ category: this.currentCategory });
    },
    async loadMoreLogs($refs) {
      this.infinitScrollState = $refs.infinitScroll?.stateChanger;
      const hasMore = await this.getLogs();
      if (hasMore) {
        this.currentOffset += this.limit;
        $refs.infinitScroll?.stateChanger.loaded();
      } else {
        $refs.infinitScroll?.stateChanger.complete();
        console.log('No more logs', this.infinitScrollState);
      }
    },
    getLogs() {
      if (this.historyDatesChecked && this.historyDates.length > 0) {
        this.searchFilterParams.startDate = this.historyDates[0];
        this.searchFilterParams.endDate = this.historyDates[1];
      }

      const searchParams = {
        upperLimit: this.limit,
        offset: this.currentOffset,
        tagIds: [],
        category: this.currentCategory,
        ...this.searchFilterParams,
      };

      return this.fetchLogByCategory(searchParams);
    },
  },
  beforeDestroy() {
    this.clearLogByCategory({ category: this.currentCategory });
  },
};
